<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-11-10 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-17 16:05:13
-->
<template>
	<div class="mt-12">
		<div class="filters-box">
			<div v-for="filter in filters" :key="filter.key" class="filter-item-box">
				<div class="filter-item" v-if="filter.list && filter.list.length > 0">
					<div class="label" style="padding-right: 24px">{{ filter.label }}</div>
					<div :class="['filter-box flex-1', expands[filter.key] ? 'expand-all' : '']" :ref="filter.key">
						<div
							:class="['item-name', form[filter.key] === item.value ? 'active' : '']"
							v-for="(item, index) in filter.list"
							:key="index"
							@click="select(filter.key, item.value, filter.key2, item.value2)"
						>
							{{ item.label }}
						</div>
					</div>
					<div v-if="filter.show" :class="['more', expands[filter.key] ? 'expand' : '']" @click="expand(filter.key)">
						{{ expands[filter.key] ? '收起' : '展开' }}
						<i class="el-icon-arrow-down"></i>
					</div>
				</div>
			</div>
			<div class="filter-item-box">
				<div class="filter-item center">
					<div class="label">活动ID</div>
					<div class="filter-box ml-24" style="height: auto">
						<el-input style="width: 200px" placeholder="请输入活动ID" v-model="form.activityId" />
					</div>
				</div>
				<div style="margin-left: 80px">
					<el-button type="primary" @click="onSubmit()">筛 选</el-button>
					<el-button @click="onClear">清 空</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
export default {
	name: 'search',
	props: ['tabName'],
	computed: {
		filters() {
			return [
				{
					label: '招商类型',
					key: 'activityType',
					list: [
						{ value: '1', label: '普通招商' },
						{ value: '2', label: '专属招商' },
					],
					show: false,
				},
			];
		},
	},
	data() {
		return {
			form: {
				activityType: '1',
				activityId: '',
			},
			activityType: [
				{
					label: '普通招商',
					value: '1',
				},
				{
					label: '专属招商',
					value: '2',
				},
			],
			expands: {},
		};
	},
	methods: {
		select(key, value, key2, value2) {
			if (this.form[key] === value) return;
			this.form[key] = value;
			if (key2) {
				this.form[key2] = value2;
			}
		},
		expand(key) {
			this.expands[key] = !this.expands[key];
			this.$refs[key][0].scrollTo(0, 0);
		},
		onClear() {
			this.form = {
				activityType: '1',
				activityId: '',
			};
			this.onSubmit();
		},
		onSubmit: throttle(function () {
			this.$emit('onSubmit', this.form);
		}, 1000),
	},
};
</script>

<style lang="less" scoped>
.filters-box {
	width: 100%;
}
.filter-item {
	width: 100%;
	display: flex;
	padding: 12px 0;
	box-sizing: border-box;
	&.center {
		align-items: center;
	}
	.label {
		width: 56px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		font-weight: bold;
		color: #666;
		text-align: right;
	}
}
.filter-box {
	display: flex;
	height: 22px;
	flex-wrap: wrap;
	overflow: hidden;
	&.expand-all {
		height: 80px;
		overflow-y: auto;
		&::-webkit-scrollbar {
			width: 6px;
		}
		&::-webkit-scrollbar-thumb {
			height: 26px;
			border-radius: 3px;
			background-color: @color-info;
		}
		.item-name {
			margin-bottom: 12px;
		}
	}
	.el-select {
		margin-right: 16px;
		width: 140px;
		::v-deep {
			&.el-input__inner {
				height: 24px;
			}
			&.el-input__icon {
				line-height: 24px;
			}
		}
	}
}
.item-name {
	padding: 2px 6px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	height: 20px;
	margin-right: 12px;
	color: #333;
	cursor: pointer;
	border-radius: 2px;
	background: #f6f9ff;
	&.active {
		color: @color-primary;
	}
	&:hover {
		color: @color-primary;
	}
}
.more {
	margin-left: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #606265;
	&:hover {
		color: @color-primary;
	}
	i {
		margin-left: 2px;
		transform: rotate(0);
		transition: all 0.3s;
	}
	cursor: pointer;
	&.expand {
		i {
			transform: rotate(180deg);
		}
	}
}
</style>
